import {InjectionToken} from "@angular/core";
//
import {NgxPopperjsOptions} from "./ngx-popperjs-options.model";

export const NGX_POPPERJS_DEFAULTS = new InjectionToken<NgxPopperjsOptions>("NGX_POPPERJS_DEFAULTS");
